import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Divider, Grid } from "@material-ui/core";
import { NavLink, useHistory } from "react-router-dom";
import Button from "@components/Button";
import Typography from "@components/Typography";
import SelectCurrency from "@components/SelectCurrency";

export default function Modal(props) {
  const classes = useStyles();
  const { handleClose, open, alertTitle, alertSubTitle, type } = props;
  const history = useHistory();
  const [value, setValue] = useState("BTC");

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleSubmit = () => {
    history.push(`/wallets/${value}/${type}`);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth="true"
      maxWidth="sm"
      className={classes.root}
    >
      <DialogTitle>
        <Typography variant="xl" isBold>
          {alertTitle}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="xs" color="seondary.tint40">
            {alertSubTitle}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogContent className={classes.selectContent}>
        <Grid container direction="column" spacing={10}>
          <Grid item>
            <SelectCurrency
              handleChange={handleChange}
              defaultValue={"BTC"}
              IRT={true}
            />
          </Grid>
          <Grid item>
            <Divider />
          </Grid>
          <Grid item container justify="flex-end" spacing={5}>
            <Grid item sm={3}>
              <Button
                variant="outlined"
                onClick={handleClose}
                fullWidth
                color="default"
              >
                {__t("Exit")}
              </Button>
            </Grid>
            <Grid item sm={3}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                fullWidth
                color="primary"
              >
                {__t("Submit")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
